<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{ `${document.translatedKind} - ${translatedOwner}` }}
            <span
              :class="`${documentStatusClass(document.translatedStatus)}`"
              class="label label--document-status"
            >
              {{ document.translatedStatus }}
            </span>
          </h4>
        </div>

        <div class="modal-body">
          <template v-if="currentStep === 'documents'">
            <div
              v-for="(attachment, index) in document.attachments"
              :key="`attachment${index}`"
              class="modal-body__row"
            >
              <div class="row">
                <div class="col-xs-12">
                  <img
                    v-if="!attachment.isPDF"
                    :src="attachment.originalUrl" class="document__preview"
                    @error="traitAsPdf(index)"
                  >
                  <embed
                    v-if="attachment.isPDF"
                    :src="attachment.originalUrl"
                    class="document__pdf-preview"
                    type="application/pdf"
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-if="currentStep === 'reprovationReasons'">
            <div class="form-group">
              <label class="form-label">Motivo da reprova*</label>
              <select class="form-control" v-model="reprovationReason">
                <option value="" disabled>
                  Selecione um motivo
                </option>
                <option v-for="(reason, index) in reprovationReasons" :value="reason.value" :key="index">
                  {{ reason.label }}
                </option>
              </select>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="$emit('close')"
          >
            Cancelar
          </button>
          <button
            v-if="currentStep === 'reprovationReasons'"
            type="button"
            class="btn btn-primary"
            @click="currentStep = 'documents'"
          >
            Voltar
          </button>
          <button
            v-if="currentStep === 'documents'"
            type="button"
            class="btn btn-danger"
            @click="currentStep = 'reprovationReasons'"
          >
            Recusar
          </button>
          <button
            v-if="currentStep === 'reprovationReasons'"
            type="button"
            class="btn btn-danger"
            @click="reproveStudent"
          >
            Confirmar Reprova
          </button>
          <button
            v-if="currentStep === 'documents'"
            type="button"
            class="btn btn-success"
            @click="$emit('approved')"
          >
            Aprovar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';
  @import 'assets/stylesheets/utils/_colors.sass';

  .document__preview {
    width: 100%;
  }

  .document__pdf-preview {
    min-height: 50vh;
    width: 100%;
  }

  .label--document-status {
    color: $white;
    display: inline-block;
    font-size: 1rem;
    margin: auto 1rem;
    vertical-align: middle;
  }

  .modal-body {
    max-height: 70vh;
    overflow-y:auto;
  }

  .modal-body__row:not(:last-child) {
    margin-bottom: $space-m;
  }
</style>
<script>

export default {
  data() {
    return {
      observations: null,
      currentStep: 'documents',
      reprovationReason: '',
    };
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    owner: {
      type: String,
      required: true,
    },
    translatedOwner: {
      type: String,
      required: true,
    },
    reprovationReasons: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (this.document.reprovationReason) {
      this.reprovationReason = this.document.reprovationReason;
    }
  },
  methods: {
    traitAsPdf(index) {
      this.$set(this.document.attachments[index], 'isPDF', true);
    },
    documentStatusClass(status) {
      if (status === 'Em análise') {
        return 'label-warning';
      } if (status === 'Reprovado') {
        return 'label-danger';
      } if (status === 'Aprovado') {
        return 'label-success';
      }
      return 'label-default';
    },
    reproveStudent() {
      if (!this.reprovationReason) {
        this.$alert.notifyAlert('Selecione um motivo de reprovação.');
        return;
      }
      this.$emit('reproved', this.reprovationReason);
    },
  },
};
</script>
